<template>
  <!-- 对话框 -->
  <el-dialog title="用户银行卡审核" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">


        <el-form-item label="审核判定:" label-width='120px'>
          <p v-if="examine_status == '1'">已通过</p>
          <el-radio-group v-model="submit_data.status" v-else>
            <el-radio-button label="1">通过</el-radio-button>
            <el-radio-button label="2">驳回</el-radio-button>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="驳回原因:" label-width='120px' v-if="submit_data.status == 2">
          <el-input type="textarea" autosize v-model="submit_data.remarks"
            :placeholder="submit_rules.remarks.placeholder">
          </el-input>
        </el-form-item>


      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="determineonSubmit"  v-if="examine_status != '1'">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': '',
      'examine_status': '',
      'remarks':'',
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.consumer_bank_card_code = _this.data;
        _this.submit_data.status = _this.examine_status;
        _this.submit_data.remarks = _this.remarks

      },

    },
    data() {
      return {

        show: false,

        // 表单数据
        submit_data: {
          consumer_bank_card_code: '',
          status: '',
          remarks: ''
        },

        submit_rules: {
          consumer_bank_card_code: {
            placeholder: '唯一编码',
            rules: {
              required: true,
              message: '唯一编码错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          status: {
            placeholder: '审核状态',
            rules: {
              required: true,
              message: '审核状态错误',
              regulation: 'egt_str',
              rulesData: 1
            }
          },
          remarks: {
            placeholder: '请输入审核备注',
            rules: {
              required: false,
              message: '审核备注错误',
              regulation: 'egt_str',
              rulesData: 5
            }
          },

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

      },

      // 提交按钮
      determineonSubmit() {
       

        if (_this.submit_data.status == 2 && _this.submit_data.remarks.length == 0) {

          _this.$message.error('驳回原因不能为空');
          return false;

        }
        _this.$post(
            '/consumer/executeConsumerBankCardStatusSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {
            _this.$message.success(res.msg)
            // 向父组件通讯刷新表格内容
            _this.$emit('onSubmit');
            // 关闭对话框
            _this.closeDialog();

          }).catch((err) => {

          })
      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>